import React from 'react';

const JS_Interview_Prep = () => {
  return (
    <div >
      <h1>JS_Interview_Prep</h1>
      <p>Placeholder component for: "JS Interview Prep"</p>
    </div>
  );
};

export default JS_Interview_Prep;
